import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=4439d896&scoped=true"
import script from "./change-password.vue?vue&type=script&lang=ts"
export * from "./change-password.vue?vue&type=script&lang=ts"
import style0 from "./change-password.vue?vue&type=style&index=0&id=4439d896&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4439d896",
  null
  
)

export default component.exports